module.exports = __webpack_public_path__ + "static/media/Item 13.d8ac3abe.jpg";